<template>
  <div v-if="notices.length" class="px-4 pb-2">
    <div
      v-for="(notice, index) in notices"
      :key="index"
      class="text-xs notice mb-2"
      :class="{ severe: notice.nivel === INCOMPLETE }"
    >
      <b>{{ notice.cocina }} — {{ notice.titulo }}</b>
      {{ notice.detalle }}
      <template v-if="notice.nivel === INCOMPLETE && purchaseWarning">
        Para comprar, este número es un piso, no un objetivo.
      </template>
    </div>
  </div>
</template>
<script>
const INCOMPLETE_LEVEL = "incompleto";

export default {
  name: "confidence-notices",
  props: {
    kitchens: { type: Array, default: () => [] },
    purchaseWarning: { type: Boolean, default: false },
  },
  data() {
    return { INCOMPLETE: INCOMPLETE_LEVEL };
  },
  computed: {
    notices() {
      return this.kitchens
        .filter((kitchen) => kitchen.confianza && kitchen.confianza.nivel !== "ok")
        .map((kitchen) => ({ ...kitchen.confianza, cocina: kitchen.name }));
    },
  },
};
</script>
<style scoped>
.notice {
  background: #fff6e0;
  border-left: 3px solid #d9a400;
  color: #6b5200;
  padding: 8px 10px;
  border-radius: 3px;
}
.notice.severe {
  background: #fdeceb;
  border-left-color: #c0392b;
  color: #7d241a;
}
</style>
